// frontend/app/pyqApi.js
// Minimal client for the PYQ MVP (plain JS), consistent with pocketGitaApi.js

export const PYQ_API = 'http://localhost:5000/pyq';

async function ok(res) {
  if (!res.ok) {
    let detail = null;
    try { detail = await res.json(); } catch {}
    const msg = (detail && (detail.detail || detail.message)) || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return res.json();
}

export async function listPapers() {
  const res = await fetch(`${PYQ_API}/papers`, { method: 'GET' });
  return ok(res);
}

export async function getPaperDoc(paperId, lang) {
  const res = await fetch(`${PYQ_API}/papers/${encodeURIComponent(paperId)}/${lang}`, { method: 'GET' });
  return ok(res);
}

export async function savePaperDoc(paperId, lang, body) {
  const url = `${PYQ_API}/papers/${encodeURIComponent(paperId)}/${lang}?token=${encodeURIComponent('dev-local-only')}`;
  const res = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return ok(res);
}

export function getPdfUrl(paperId) {
  return `${PYQ_API}/papers/${encodeURIComponent(paperId)}/pdf`;
}
